module.exports = __webpack_public_path__ + "img/dementia-02-risk-factor.873895e1.jpg";